import { TableColumn } from '../DataTable.vue.d';
import useDataTableStore, {
  DataTableColumnConfig,
} from '../store/dataTable.store';

const sortDefaultToMatchConfig = (
  defaultColumns: TableColumn<any>[],
  configColumns: DataTableColumnConfig[],
): TableColumn<any>[] => {
  const orderMap = new Map<string, number>();

  configColumns.forEach((conf, index) => {
    orderMap.set(conf.field, index);
  });

  // Sort default columns based on the order in config
  return [...defaultColumns].sort((a, b) => {
    const indexA = orderMap.get(a.field);
    const indexB = orderMap.get(b.field);

    // Handle columns that exist in both arrays
    if (indexA !== undefined && indexB !== undefined) {
      return indexA - indexB;
    }

    // Handle columns that exist only in default columns (put them at the end)

    if (indexA === undefined && indexB === undefined) {
      return 0; // Keep relative order if both not found
    }
    // Put non-matching columns at end
    if (indexA === undefined) return 1;
    return -1;
  });
};

export default async function readConfig(
  tableId: string,
  defaultColumns: TableColumn<any>[],
): Promise<TableColumn<any>[]> {
  const { config } = await useDataTableStore();
  const tableConfig = config[tableId];

  if (tableConfig && tableConfig.length > 0) {
    return sortDefaultToMatchConfig(defaultColumns, tableConfig)
      .map((col) => {
        const foundConf = tableConfig.find((conf) => conf.field === col.field);

        if (col.visible === false) return undefined; // To hide column if the programmer set the column visibility to false

        return {
          ...col,
          ...foundConf,
          visible: col.fixed || foundConf?.visible,
        } as TableColumn<any>;
      })
      .filter((col): col is TableColumn<any> => !!col); // Make it assignable to type TableColumn[], because `map` method produce (TableColumn | undefined)[]
  }

  return defaultColumns.filter((col) => col.visible !== false);
}
